import { Checkbox, FormControlLabel, Button } from "@mui/material";
import React from "react";
import Grid from "@mui/material/Unstable_Grid2";
import "./Referfriend.scss";
import RKTextField from "../../../../Supporting files/RKTextField/RKTextField";
import SelectDropdown from "../../../../Supporting files/SelectDropdown/SelectDropdown";

function Referfriend() {
  const [referralCode, setReferralCode] = React.useState(false);
  const [referCode, setReferCode] = React.useState("");
  const [fullName, setFullName] = React.useState("");
  const [gender, setGender] = React.useState("");
  const [age, setAge] = React.useState("");
  const [howDoYouKnow, setHowDoYouKnow] = React.useState("");
  const [mobile, setMobile] = React.useState("");
  const [email, setEmail] = React.useState("");

  let gender_data = [
    { key: "Male", value: "Male" },
    { key: "Female", value: "Female" },
  ];
  let age_data = [
    { key: "20 years", value: "20 years" },
    { key: "21 years", value: "21 years" },
    { key: "22 years", value: "22 years" },
    { key: "23 years", value: "23 years" },
  ];
  let howDoYouKnow_data = [
    { key: "Friend", value: "Friend" },
    { key: "Colleague", value: "Colleague" },
    { key: "Family Member", value: "Family Member" },
  ];

  const updateMasterState = (attrName: any, value: string) => {
    attrName(value);
  };

  return (
    <Grid container spacing={2} className="referFriend">
      <Grid xs={12}>
        <h3 className="mb-0">Refer a friend</h3>
      </Grid>
      <Grid xs={12} className="checkbox">
        <FormControlLabel
          control={
            <Checkbox
              style={{
                color: "#2166AA",
              }}
              checked={referralCode}
              onClick={() => {
                setReferralCode(!referralCode);
              }}
            />
          }
          label="I have a referral code."
        />
      </Grid>
      <Grid xs={12} sx={{ paddingLeft: "0px" }}>
        {referralCode == true ? (
          <Grid container spacing={2}>
            <Grid xs={4} md={3} lg={2}>
              <RKTextField
                class_name="inputField mb-5"
                title="Referral Code"
                value={referCode}
                attrName={setReferCode}
                value_update={updateMasterState}
                warn_status={false}
              />
            </Grid>
          </Grid>
        ) : null}

        <Grid container spacing={2}>
          <Grid xs={8} md={6} lg={4}>
            <RKTextField
              class_name="inputField mb-5"
              title="Full Name"
              value={fullName}
              attrName={setFullName}
              value_update={updateMasterState}
              warn_status={false}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid xs={6} md={3} lg={2} className="inputField mb-5">
            <SelectDropdown
              class_name="inputField"
              title="Gender"
              value={gender}
              attrName={setGender}
              value_update={updateMasterState}
              dropdown_data={gender_data}
              warn_status={false}
            />
          </Grid>
          <Grid xs={6} md={3} lg={2} className="inputField mb-5">
            <SelectDropdown
              class_name="inputField"
              title="Age"
              value={age}
              attrName={setAge}
              value_update={updateMasterState}
              dropdown_data={age_data}
              warn_status={false}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid xs={6} md={4} className="inputField mb-5">
            <SelectDropdown
              class_name="inputField"
              title="How do you know?"
              value={howDoYouKnow}
              attrName={setHowDoYouKnow}
              value_update={updateMasterState}
              dropdown_data={howDoYouKnow_data}
              warn_status={false}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid xs={6} md={3} lg={2}>
            <RKTextField
              class_name="inputField mb-5"
              title="Mobile"
              value={mobile}
              attrName={setMobile}
              value_update={updateMasterState}
              warn_status={false}
            />
          </Grid>
          <Grid xs={6} md={4} lg={3}>
            <RKTextField
              class_name="inputField mb-5"
              title="Email"
              value={email}
              attrName={setEmail}
              value_update={updateMasterState}
              warn_status={false}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid xs={12} className="ctaBtn mb-5">
            <Button className="submitBtn">Save Changes</Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Referfriend;
